<section class="service-page globle-page"></section>

<section class="home-service globle-border mt-5 pt-5">
  <div class="container page-body-wrapper  mt-3 ">
    <div class="row">
      <div class="col-lg-8 order-lg-2">
        <h4 style="
        margin-inline-start: 5rem;
        overflow: hidden;
    "> {{ "Blog" | translate }}</h4>
      </div>
      <div class="col-lg-4 order-lg-1">
        <ul class=" mt-5 pt-5">
          <li class="mt-2">
            {{ "Recent_Posts" | translate }}
          </li>
          <li>
            {{ "General_News" | translate }}
          </li>
          <li>
            {{ "Press_Releases" | translate }}
          </li>
        </ul>
      </div>
    </div>
    <!-- /row -->
  </div>
</section>
